import QS from 'query-string';

// [App scheme(deep link) 정의 wiki](https://quicket.atlassian.net/wiki/spaces/BUN/pages/2548007019/v2)

const URL = 'bunjang://';

export type ID = string | number;
// TODO: 검색 쿼리 타입 추가하기
type SearchApiQuery = Partial<unknown>;

/** 웹뷰 새로고침 */
export const refreshWebviewOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'refresh' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 웹뷰 뒤로가기 후 새로고침 */
export const backAndRefreshWebviewOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'back_and_refresh' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 웹뷰 닫기 */
export const closeWebviewOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'close' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 웹뷰 이동 (헤더 O) */
export const goToWebviewOnApp = (query: { url: string; reloadable?: boolean }) => {
  const to = URL + QS.stringifyUrl({ url: 'webview', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 웹뷰 이동 (헤더 X) */
export const goToFullWebviewOnApp = ({ url }: { url: string }) => {
  // `QS.stringifyUrl` 의 경우 기본 옵션으로 인코딩을 하기 때문에 `url` 을 인코딩하지 않는다.
  const to = URL + QS.stringifyUrl({ url: 'full_webview', query: { url } });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 외부 브라우저 이동 */
export const goToBrowserOnApp = ({ url }: { url: string }) => {
  // `QS.stringifyUrl` 의 경우 기본 옵션으로 인코딩을 하기 때문에 `url` 을 인코딩하지 않는다.
  const to = URL + QS.stringifyUrl({ url: 'browser', query: { url } });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 팝업 노출 */
export const showPopupOnApp = (query: { message: string }) => {
  const to = URL + QS.stringifyUrl({ url: 'popup', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 상품 상세 화면으로 이동 */
export const goToProductOnApp = (query: { pid: ID }) => {
  const to = URL + QS.stringifyUrl({ url: 'product', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 상품 상세 화면으로 이동 후 페이 옵션이 떠야 하는 경우 */
export const goToProductWithPayOptionOnApp = (query: { pid: ID }) => {
  const to = URL + QS.stringifyUrl({ url: 'pay_opt_in_product?ref=PRODUCT_DETAIL', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 상품 등록 화면으로 이동 */
export const goToNewProductOnApp = (
  query: Partial<{
    categoryId: ID;
    title: string;
    price: number;
    tags: string;
    /** 수량 */
    qty: number;
    /** 협의 가능 */
    demand_contact: boolean;
    /** 배송비 포함 */
    free_shipping: boolean;
    /** 교환 가능 */
    exchange: boolean;
  }>,
) => {
  const to = URL + QS.stringifyUrl({ url: 'item_register', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 상점 수정 화면으로 이동 */
export const goToEditProductOnApp = (query: { pid: ID }) => {
  const to = URL + QS.stringifyUrl({ url: 'product_modify', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 상점 상세 화면으로 이동 */
export const goToShopOnApp = ({ uid }: { uid: ID }) => {
  const to = URL + QS.stringifyUrl({ url: 'shop', query: { val: uid } });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 상점 판매 상품 목록 화면으로 이동 */
export const goToShopProductsOnApp = (query: { uid: ID; name?: string } & SearchApiQuery) => {
  const to = URL + QS.stringifyUrl({ url: 'profile_select_productlist', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 웹뷰에서 찜하기를 하는 경우 네이티브 앱에 해당 정보 전달*/
export const toggleFavoriteOnApp = (query: { pid: ID; type: 'add' | 'delete' }) => {
  const to = URL + QS.stringifyUrl({ url: 'myfav', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 후기 목록 화면으로 이동 */
export const goToReviewsOnApp = ({ uid, name }: { uid: ID; name?: string }) => {
  const to = URL + QS.stringifyUrl({ url: 'review_list', query: { val: uid, name } });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 후기 작성 화면으로 이동 */
export const goToNewReviewOnApp = ({ uid, name }: { uid: ID; name?: string }) => {
  const to = URL + QS.stringifyUrl({ url: 'review', query: { val: uid, name } });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 검색 화면으로 이동 */
export const goToSearchOnApp = (query: { keyword: string; isFilterForceShow?: boolean } & SearchApiQuery) => {
  const to = URL + QS.stringifyUrl({ url: 'review', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 리워드 광고 화면으로 이동 */
export const goToRewardAdsOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'reward_ads' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 찜 목록 화면으로 이동 */
export const goToFavoritesOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'fav_list' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 최근 본 상품 화면으로 이동 */
export const goToRecentViewOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'recent' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 내 피드 화면으로 이동 */
export const goToMyFeedOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'my_feed' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 우리 동네 검색 결과 화면으로 이동 */
export const goToNeighborhoodOnApp = (query: SearchApiQuery) => {
  const to = URL + QS.stringifyUrl({ url: 'neighborhood', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 지역 검색 결과 화면으로 이동 */
export const goToLocationOnApp = (query: SearchApiQuery) => {
  const to = URL + QS.stringifyUrl({ url: 'location', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 전체 메뉴 화면으로 이동 */
export const goToMeuOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'all_menu' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 카테고리 화면으로 이동 */
export const goToCategoryOnApp = (query: { cid: ID } & SearchApiQuery) => {
  const to = URL + QS.stringifyUrl({ url: 'category', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 브랜드 화면으로 이동 */
export const goToBrandOnApp = (query: { bid: ID } & SearchApiQuery) => {
  const to = URL + QS.stringifyUrl({ url: 'brand', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 브랜드 편집 화면으로 이동 */
export const goToEditBrandOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'brand_search' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 팔로잉하는 브랜드 화면으로 이동 */
export const goToFollowingBrandOnApp = (query: { bid?: ID }) => {
  const to = URL + QS.stringifyUrl({ url: 'following_brands', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 홈 화면으로 이동 */
export const goToHomeOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'home' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 번개톡 목록 화면으로 이동 */
export const goToTalkListOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'talk_list' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 번개톡 화면으로 이동 */
export const goToTalkOnApp = (query: { uid: ID; pid?: ID }) => {
  const to = URL + QS.stringifyUrl({ url: 'contact?type=buntalk', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 번개톡 화면으로 이동 후 페이 옵션이 떠야하는 경우 */
export const goToTalkWithPayOptionOnApp = (query: { uid: ID; pid?: ID; ref: 'TALK_MESSAGE' | 'TALK_HEADER' }) => {
  const to = URL + QS.stringifyUrl({ url: 'pay_opt_in_talk', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 마이샵 화면으로 이동 */
export const goToMyShopOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'my_shop' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 마케팅 수신 동의 화면으로 이동 */
export const goToMarketingPushAgreeOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'marketing_push_agree' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 오퍼월 미션 (클릭하고 받기, 참여하고 받기) 화면으로 이동 */
export const goToOfferwallOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'offerwall' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 홈 추천 컨테이너 더보기 화면으로 이동 */
export const goToHomeRecommendOnApp = (query: { containerId: ID }) => {
  const to = URL + QS.stringifyUrl({ url: 'rec_container', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 번개 포인트 화면으로 이동 */
export const goToPointOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'bun_point' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 즐겨찾는 검색 화면으로 이동 */
export const goToQueryPresetOnApp = (query: { val?: 'FEED' | 'QUERY_LIST' }) => {
  const to = URL + QS.stringifyUrl({ url: 'query_preset', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 판매 상품 관리 화면으로 이동 */
export const goToProductManageOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'product_manage' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 설정 화면으로 이동 */
export const goToSettionOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'setting' });
  return { go: () => (globalThis.window.location.href = to), to };
};
/** 장바구니 화면으로 이동 */
export const goToCartOnApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'cart' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 2nd 탭의 피드 탭으로 이동 */
export const goToFeedOnApp = (query: { val?: 'ALL' | 'SHOP' | 'BRAND' | 'QUERY_PRESET'; cid?: ID }) => {
  const to = URL + QS.stringifyUrl({ url: 'interest_feed', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 2nd 탭의 각 탭으로 이동 */
export const goToInterestTabOnApp = (query: { val?: 'SHOP' | 'BRAND' | 'QUERY_PRESET' }) => {
  const to = URL + QS.stringifyUrl({ url: 'interest_tab', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** OS 기본 공유 팝업을 보여준다 (AOS 전용) */
export const showSharePopupOnAosApp = (query: { title?: string; content: string }) => {
  const to = URL + QS.stringifyUrl({ url: 'share?type=os', query });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** 내 정보 새로고침 (AOS 전용) */
export const refreshMyInfoOnAosApp = () => {
  const to = URL + QS.stringifyUrl({ url: 'converted_to_' });
  return { go: () => (globalThis.window.location.href = to), to };
};

/** pull to refresh 기능 on/off (AOS 전용) */
export const togglePullToRefreshOnAosApp = (query: { val: 'y' | 'n' }) => {
  const to = URL + QS.stringifyUrl({ url: 'pull_to_refresh', query });
  return { go: () => (globalThis.window.location.href = to), to };
};
